import React from "react";
import { useParams, useHistory } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { summaryTheme as t } from "./styles";
import SummaryAccountDetailContent from "./SummaryAccountDetailContent";

/**
 * Route: /summary/account/:accountNumber
 * Renders account detail with "Back to Summary" link.
 */
const SummaryAccountDetail = () => {
  const { accountNumber } = useParams();
  const history = useHistory();

  if (!accountNumber) {
    return (
      <Box sx={{ padding: "1.5rem 2rem", fontFamily: t.fontFamily, backgroundColor: t.colors.background, minHeight: "100vh" }}>
        <Typography sx={{ color: t.colors.textMuted }}>Missing account number.</Typography>
        <Typography
          component="span"
          onClick={() => history.push("/summary")}
          sx={{ color: t.colors.accent, cursor: "pointer", textDecoration: "underline", mt: 1, display: "inline-block" }}
        >
          Go back
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        padding: { xs: "1rem", sm: "1.5rem", md: "2rem" },
        mb: "1.5rem",
        backgroundColor: t.colors.background,
        minHeight: "100vh",
        fontFamily: t.fontFamily,
      }}
    >
      <SummaryAccountDetailContent accountNumber={accountNumber} showBackLink />
    </Box>
  );
};

export default SummaryAccountDetail;
